import { render, staticRenderFns } from "./ProfileMobile.vue?vue&type=template&id=b6166d04&"
import script from "./ProfileMobile.vue?vue&type=script&lang=js&"
export * from "./ProfileMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports